import React, { Dispatch, SetStateAction, useMemo } from "react"

import { Provider } from "lib/types/generated/graphql-types"
import { PROVIDER_TYPE } from "lib/types/common"

import { Container, EmptyList, Wrapper } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "../../Ui/Messages/ErrorMessage"
import { getLoadingRow, LedyerConfigTableRow } from "./LedyerConfigTableRow"
import TableBlurLoading from "../../Ui/Table/TableBlurLoading"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  providers: Provider[]
  error: object | undefined
  setEditId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

export const LedyerConfigTable = ({ providers, setEditId, error, loading }: Props) => {
  const ledyerProviders = providers?.filter((p) => p.type === PROVIDER_TYPE.LEDYER) || []

  const tableHeader = useMemo(
    () => (
      <TableHeader iconHeader>
        <div>Identifier</div>
        <div>Base url</div>
        <div className="hideOnSmallScreens">Created</div>
        <div className="hideOnSmallScreens">Updated</div>
      </TableHeader>
    ),
    []
  )

  if (loading)
    return <TableBlurLoading numberOfRows={2} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (ledyerProviders?.length < 1)
    return (
      <EmptyList>
        <p> No configurations added</p>
      </EmptyList>
    )
  if (!providers) return null

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Ledyer configurations. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...ledyerProviders].map((provider) => (
          <LedyerConfigTableRow key={provider.id} id={provider.id} setEditId={setEditId} />
        ))}
      </Container>
    </Wrapper>
  )
}
